// @flow
import cloneDeep from 'lodash/cloneDeep';
import type { Action } from 'app/common/redux/types';

export type VideoPin = {
  pinId: string,
  currentTime?: ?number,
};

export type VideosAutoplaying = {
  organicVideosAutoplaying: {
    [key: string]: VideoPin,
  },
  promotedVideosAutoplaying: {
    [key: string]: VideoPin,
  },
};

export type State = {
  videosAutoplaying: VideosAutoplaying,
  isAutoplay: boolean,
  showTypeaheadOverlay: boolean,
};

export const initialState = {
  videosAutoplaying: {
    organicVideosAutoplaying: {},
    promotedVideosAutoplaying: {},
  },
  isAutoplay: false,
  showTypeaheadOverlay: false,
};

const app = (state: State = initialState, action: Action): State => {
  if (action.type === 'TOGGLE_TYPEAHEAD_OVERLAY') {
    return {
      ...state,
      showTypeaheadOverlay: action.payload.value,
    };
  } else if (action.type === 'SET_CURRENT_VIDEO') {
    const { payload } = action;
    const { pinId, isPromoted, currentTime } = payload;
    const { videosAutoplaying } = state;
    const { promotedVideosAutoplaying, organicVideosAutoplaying } = videosAutoplaying;
    const promotedVideosCopy = cloneDeep(promotedVideosAutoplaying);
    const organicVideosCopy = cloneDeep(organicVideosAutoplaying);

    if (isPromoted) {
      promotedVideosCopy[pinId] = {
        pinId,
        currentTime,
      };
    } else {
      organicVideosCopy[pinId] = {
        pinId,
        currentTime,
      };
    }

    return {
      ...state,
      videosAutoplaying: {
        promotedVideosAutoplaying: promotedVideosCopy,
        organicVideosAutoplaying: organicVideosCopy,
      },
    };
  } else if (action.type === 'UNSET_CURRENT_VIDEO') {
    const { payload } = action;
    const { pinId, isPromoted } = payload;
    const { videosAutoplaying } = state;
    const { organicVideosAutoplaying, promotedVideosAutoplaying } = videosAutoplaying;
    const promotedVideosCopy = cloneDeep(promotedVideosAutoplaying);
    const organicVideosCopy = cloneDeep(organicVideosAutoplaying);

    if (isPromoted) {
      delete promotedVideosCopy[pinId];
    } else {
      delete organicVideosCopy[pinId];
    }

    return {
      ...state,
      videosAutoplaying: {
        promotedVideosAutoplaying: promotedVideosCopy,
        organicVideosAutoplaying: organicVideosCopy,
      },
    };
  } else if (action.type === 'SET_IS_AUTOPLAY') {
    return {
      ...state,
      isAutoplay: action.payload.isAutoplay,
    };
  }

  return state;
};

export default app;
